import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FiChevronDown, FiBell } from "react-icons/fi";
import { RxDashboard } from "react-icons/rx";
import { MdAdsClick, MdOutlinePlace } from "react-icons/md";
import logo from "../assets/images/logo.png";
import "../assets/css/Header.css";
import { CgLogOut } from "react-icons/cg";
import { TiWeatherCloudy } from "react-icons/ti";
import { MdOutlineBiotech, MdOutlineModelTraining } from "react-icons/md";

const Header = () => {
  const [region, setRegion] = useState("Ethiopia");
  const navigate = useNavigate();
  const location = useLocation();
  const locationName = location.state?.locationName || "Ethiopia";

  const handleLogout = () => {
    const confirmLogout = window.confirm("Are you sure you want to Log out?");
    if (confirmLogout) {
      localStorage.clear();

      navigate("/");
    }
  };

  const isActive = (path) => {
    if (path === "dashboard") {
      return location.pathname === "/" || location.pathname === "/dashboard";
    }
    return (
      location.pathname === `/${path}` ||
      location.pathname.startsWith(`/${path}/`)
    );
  };
  const urlPath = location.pathname;

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-left">
          <div className="logo-container">
            <div className="logo-icon">
              <img src={logo} alt="Icon Logo" width={24} height={24} />
            </div>
            <span className="logo-text">NTD Dashboard</span>
          </div>
          <nav className="nav">
            <button
              className={`nav-item ${
                isActive("region-select") ? "active" : ""
              }`}
              onClick={() => navigate("/region-select")}
            >
              <MdAdsClick
                style={{
                  color: isActive("region-select") ? "#2563eb" : "#64748b",
                }}
                className="icon"
              />
              <span>Region Select</span>
            </button>
            <button
              className={`nav-item ${isActive("dashboard") ? "active" : ""}`}
              onClick={() => navigate("/dashboard")}
            >
              <RxDashboard
                className="icon"
                style={{
                  color: isActive("dashboard") ? "#2563eb" : "#64748b",
                }}
              />
              <span>Dashboard</span>
            </button>
            <button
              className={`nav-item ${isActive("hotspot") ? "active" : ""}`}
              onClick={() => navigate("/hotspot")}
            >
              <MdOutlinePlace
                className="icon"
                style={{
                  color: isActive("hotspot") ? "#2563eb" : "#64748b",
                }}
              />
              <span>Hotspot Mapping</span>
            </button>

            <button
              className={`nav-item ${isActive("weather") ? "active" : ""}`}
              onClick={() => navigate("/weather")}
            >
              <TiWeatherCloudy
                className="icon"
                style={{
                  color: isActive("weather") ? "#2563eb" : "#64748b",
                }}
              />
              <span>Weather</span>
            </button>
            <button
              className={`nav-item ${isActive("risk-prediction") ? "active" : ""}`}
              onClick={() => navigate("/risk-prediction")}
            >
              <MdOutlineBiotech
                className="icon"
                style={{
                  color: isActive("risk-prediction") ? "#2563eb" : "#64748b",
                }}
              />
              <span>Risk Prediction</span>
            </button>
            <button
              className={`nav-item ${isActive("model-training") ? "active" : ""}`}
              onClick={() => navigate("/model-training")}
            >
              <MdOutlineModelTraining
                className="icon"
                style={{
                  color: isActive("model-training") ? "#2563eb" : "#64748b",
                }}
              />
              <span>Model Training</span>
            </button>
            {/* <button 
              className={`nav-item ${isActive('analytics')}`}
              onClick={() => navigate("/analytics")}
            >
              <SiGoogleanalytics className="icon" />
              <span>Analytics</span>
            </button> */}
            
          </nav>
        </div>
        <div className="header-right">
          {/* {urlPath == "/dashboard" && (
            <div className="region-select">
              <select
                value={locationName}
                onChange={(e) => setRegion(e.target.value)}
              >
                <option>{locationName}</option>
              </select>
              <FiChevronDown className="dropdown-icon" />
            </div>
          )} */}
          <CgLogOut className="logout" onClick={handleLogout} />
        </div>
      </div>
    </header>
  );
};

export default Header;
